import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import palette from 'library/theme/palette';
import MDialog from './MDialog';

const StatusDetailsDialog = ({
  open,
  onClose,
  title = 'Status Details',
  items = [],
  idKey = 'shipmentId',
  nameKey = 'shipperName',
  detailsKey = 'statusDetails',
  onIdClick,
  sx,
}) => {
  const defaultSx = {
    '& .MuiDialog-paper': { maxHeight: '80%' },
    '& .MuiDialogActions-root': {
      backgroundColor: 'background.paper',
      borderTop: `1px solid ${palette.gray.light}`,
      bottom: 0,
      pb: 2,
      position: 'sticky',
      pt: 2,
      zIndex: 1,
    },
    '& .MuiDialogContent-root': { mb: 1, pb: 0 },
    '& .MuiDialogTitle-root': { color: palette.text.primary, fontSize: 20, pb: 1 },
    ...sx,
  };

  return (
    <MDialog
      header={title}
      onClose={onClose}
      open={open}
      rightButtonAction={onClose}
      rightButtonText="Close"
      sx={defaultSx}
    >
      <Box>
        {items.map(item => {
          const id = item?.[idKey];
          const name = item?.[nameKey];
          const details = item?.[detailsKey];
          return (
            details && (
              <Stack key={id} spacing={0.5} sx={{ my: 2 }}>
                <Box>
                  <Typography
                    display="inline"
                    onClick={() => onIdClick && id && onIdClick(id)}
                    sx={{
                      color: 'green',
                      cursor: onIdClick ? 'pointer' : 'default',
                      fontSize: 14,
                      fontWeight: 'bold',
                      textDecoration: onIdClick ? 'underline' : 'none',
                    }}
                    variant="body1"
                  >
                    {id}
                  </Typography>
                  {name && (
                    <Typography
                      display="inline"
                      sx={{ color: palette.graphic.dark, fontSize: 14, fontWeight: 'bold' }}
                      variant="body2"
                    >
                      {' '}
                      to {name}
                    </Typography>
                  )}
                </Box>
                {details && (
                  <Typography sx={{ fontSize: 14 }} variant="body1">
                    {details}
                  </Typography>
                )}
              </Stack>
            )
          );
        })}
      </Box>
    </MDialog>
  );
};

export default StatusDetailsDialog;

StatusDetailsDialog.propTypes = {
  detailsKey: PropTypes.string,
  idKey: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  nameKey: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onIdClick: PropTypes.func,
  open: PropTypes.bool.isRequired,
  sx: PropTypes.shape({}),
  title: PropTypes.string,
};
StatusDetailsDialog.defaultProps = {
  detailsKey: 'statusDetails',
  idKey: 'shipmentId',
  nameKey: 'shipperName',
  onIdClick: undefined,
  sx: {},
  title: 'Status Details',
};
